import React, { useRef, useEffect } from 'react'
import { useFileUpload } from '../util/uploadGoogleCloud'
//import previewImage from './file-util/preview/index'

const Image = ({ item, value, validationMessage, handleChange, formData }) => {
  const disabled = typeof item.disabled === 'function' ? item.disabled(formData) : item.disabled || false
  const inputFileRef = useRef(null)
  const [selectedFile, setSelectedFile] = React.useState(null)
  const [selectedFileName, setSelectedFileName] = React.useState(null)

  const [imageSrc, setImageSrc] = React.useState('/assets/images/loading.gif')

  //const { upload, progress } = useGoogleCloudUpload();
  const { uploadFile, progress } = useFileUpload()

  const fileName = selectedFileName?.name || formData[`${item.name}_url`]?.split('/').pop() || 'your_file.*'

  // handle Drop file
  const handleImageChange = async (e) => {
    const file = e.target.files[0]
    if (file) {
      setSelectedFileName({ name: file.name, size: file.size })
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setSelectedFile(reader.result)
        handleChange(reader.result, item?.name)

        if (item?.googleUpload) {
          uploadFile(file)
          //upload(reader.result, fileType, fileExtension);
        }
      }
    } else {
      setSelectedFileName(null)
      setSelectedFile(null)
      handleChange(null, item?.name)
    }
    handleChange('', `${item.name}_url`)

    console.log(`${item.name}_url`, formData[`${item.name}_url`])
  }

  const handleClick = () => {
    inputFileRef?.current?.click()
  }

  useEffect(() => {
    setSelectedFile(value)
    if (value === item?.defaultValue) {
      setSelectedFileName(item?.defaultValue?.substring(item?.defaultValue?.lastIndexOf('/') + 1))
    }
    if (value === null || value === '') {
      if (inputFileRef?.current) {
        inputFileRef.current.value = null
      }
      if (formData[`${item.name}_url`]) {
        handleChange('', `${item.name}_url`)
      }
    }

    /*if (value) {
            previewImage.glb(value).then((imageBase64) => {
                setImageSrc(imageBase64);
            });
        }*/
  }, [value])
  const uploaded = formData?.[`${item.name}_url`] || null
  const inputValue = value || ''
  // Return Input in view
  return (
    <div className={'relative overflow-hidden group'}>
      {!selectedFile ? (
        <div
          className={`transition ${
            disabled && 'disabled'
          } flex flex-col gap-xs h-[190px] h-[76px] w-full bg-white rounded-md shadow border border-dashed border-gray-200 justify-center items-center hover:border-primary-500 cursor-pointer ${
            item?.innerClassName || ''
          } ${validationMessage ? 'border-red-500 border-2' : ''}`}
          onClick={() => {
            handleClick()
          }}
        >
          <div className="w-[1260px] text-center text-gray-400 text-title-lg ">
            {item?.placeholder ? item.placeholder : 'Drag and drop your files here'}
          </div>
          <div className="w-[1260px] text-center text-gray-400 text-text-sm ">
            {item?.hint ? item?.hint : 'or click to select files from your device.'}
          </div>
        </div>
      ) : (
        <div className="w-full h-[76px] px-3.5 py-4 bg-gray-100 rounded-md justify-center items-center gap-2.5 inline-flex relative overflow-hidden">
          {/*{<div>
                        <img src={imageSrc} className={"w-[50px] h-[50px]"}/>
                    </div>}*/}
          <div className="grow shrink basis-0 self-stretch flex-col justify-center items-start gap-1 inline-flex align-baseline">
            <div className="self-stretch text-gray-900 text-title-sm  ">
              {' '}
              {/*{selectedFileName?.name || formData[`${item.name}_name`]}*/}
              {fileName}
            </div>
            <div className="self-stretch text-gray-400 text-text-sm inline-flex gap-2">
              {uploaded && (
                <div
                  className={
                    'bg-primary-500 text-text-xs justify-center items-center px-sm py-[0px] rounded-sm text-white inline-flex'
                  }
                >
                  Uploaded
                </div>
              )}
              {formatFileSize(value)}
            </div>
          </div>
          <div className="text-red-500 text-sm font-icon-regular hidden"></div>
          {progress == null && (
            <div className={'absolute h-[5px] w-[100%] left-0 bottom-0 bg-gray-200'}>
              <div className={`bg-primary-500  h-[5px]`} style={{ width: `${progress}%` }}></div>
            </div>
          )}
          <div className="flex flex-row gap-xs opacity-0 group-hover:opacity-100 transition absolute top-sm right-sm">
            {/*<div
                            onClick={(e) => {
                                handleDelete();
                                e.stopPropagation();
                            }}
                            className="text-red-500 text-sm font-icon-regular w-[34px] h-[34px] flex items-center justify-center hover:bg-red-500 hover:text-white hover:text-shadow-sm transition rounded-sm cursor-pointer"
                        >
                            
                        </div>*/}
            {uploaded && (
              <div
                onClick={(e) => {
                  window.open(uploaded, '_blank')
                  e.stopPropagation()
                }}
                className="text-primary-700 text-sm font-icon-regular w-[34px] h-[34px] flex items-center justify-center hover:bg-primary-500 hover:text-white hover:text-shadow-sm transition rounded-sm cursor-pointer"
              >
                
              </div>
            )}
          </div>
        </div>
      )}
      <div className={'hidden'}>
        <input
          accept={item.accept || 'image/*'}
          ref={inputFileRef}
          type={'file'}
          disabled={disabled}
          onChange={(e) => {
            if (handleChange) {
              handleImageChange(e)
            }
          }}
        />
      </div>
    </div>
  )
}

function formatFileSize(val) {
  const bytes = calculateFileSizeFromBase64(val)
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i]
}
export default Image

const calculateFileSizeFromBase64 = (base64String) => {
  // Remove the Data URL prefix if exists
  const BASE64_MARKER = ';base64,'
  const pos = base64String.indexOf(BASE64_MARKER) + BASE64_MARKER.length
  const base64WithoutPrefix = base64String.substring(pos)

  // Calculate file size
  let fileSize = (base64WithoutPrefix.length * 3) / 4 // in bytes
  fileSize -= (base64String.match(/=/g) || []).length // subtract padding bytes

  return fileSize
}
